const HELPDESK_OWNERSHIP_QUERY_KEYS = [
  'action',
  'draftId',
  'from',
  'problemPicker',
  'problemPickerReturnUrl',
  'threadId',
] as const;

export const stripHelpdeskOwnershipSearch = (search: string): string => {
  const params = new URLSearchParams(search);
  for (const key of HELPDESK_OWNERSHIP_QUERY_KEYS) params.delete(key);
  const serialized = params.toString();
  return serialized ? `?${serialized}` : '';
};
